/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Neat_Duck_LookInputs */

const en_free_neat_duck_look = /** @type {(inputs: Free_Neat_Duck_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const de_free_neat_duck_look = /** @type {(inputs: Free_Neat_Duck_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Free_Neat_Duck_LookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const free_neat_duck_look = /** @type {((inputs?: Free_Neat_Duck_LookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Neat_Duck_LookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_neat_duck_look(inputs)
	return de_free_neat_duck_look(inputs)
});